/**
 * @generated SignedSource<<f25d4aabf9cec627db321365a6495d21>>
 * @relayHash 5cf328a3c030bee2ca8526dcf0940254
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 609bc266845276bd914f594b5f769b34dbd226917a96e061d2ab9d4a74023f94

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholderGroupsPageQuery$variables = {
  after?: string | null | undefined;
  first: number;
};
export type StakeholderGroupsPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"stakeholderGroup_AtlassianStakeholderManagement">;
};
export type StakeholderGroupsPageQuery = {
  response: StakeholderGroupsPageQuery$data;
  variables: StakeholderGroupsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StakeholderGroupsPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "stakeholderGroup_AtlassianStakeholderManagement"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StakeholderGroupsPageQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersConnection",
        "kind": "LinkedField",
        "name": "stakeholderComms_getStakeholderGroupsWithStakeholders",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsStakeholderGroupAndStakeholdersEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "StakeholderCommsStakeholderGroupsAndStakeholders",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "StakeholderCommsStakeholderGroup",
                    "kind": "LinkedField",
                    "name": "group",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "logoUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "services"
                      }
                    ]
                  },
                  {
                    "concreteType": "StakeholderCommsStakeholder",
                    "kind": "LinkedField",
                    "name": "stakeholders",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "avatar"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ownerName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ownerAvatar"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "StakeholderCommsPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "handle": "connection",
        "key": "StakeholderGroupTable_stakeholderComms_getStakeholderGroupsWithStakeholders",
        "kind": "LinkedHandle",
        "name": "stakeholderComms_getStakeholderGroupsWithStakeholders"
      }
    ]
  },
  "params": {
    "id": "609bc266845276bd914f594b5f769b34dbd226917a96e061d2ab9d4a74023f94",
    "metadata": {},
    "name": "StakeholderGroupsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d3fd21007ec2705dd2824d2ae27361b3";

export default node;
